/**
 * This component wraps React-Router's Redirect by providing name-based routing.
 * (Helps to narrow down the scope of possible format changes to routes.)
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, useParams } from 'react-router-dom';

import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { DEFAULT_LOCALE, getActiveLocale, isSupportedLocale } from '../../util/locale';
import { pathByRouteName } from '../../util/routes';

const NamedRedirect = props => {
  const routeConfiguration = useRouteConfiguration();
  const routeParams = useParams();
  const { name, search, state, params, push } = props;
  const locale =
    (params && isSupportedLocale(params.locale) && params.locale) ||
    (isSupportedLocale(routeParams?.locale) && routeParams.locale) ||
    getActiveLocale() ||
    DEFAULT_LOCALE;
  const pathname = pathByRouteName(name, routeConfiguration, { locale, ...params });
  return <Redirect to={{ pathname, search, state }} push={push} />;
};

const { bool, object, string } = PropTypes;

NamedRedirect.defaultProps = { search: '', state: {}, push: false, params: {} };

NamedRedirect.propTypes = {
  name: string.isRequired,
  search: string,
  state: object,
  push: bool,
  params: object,
};

export default NamedRedirect;
